import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>

      <div className="container-fluid">
        <footer className="text-center text-dark" style={{ backgroundColor: '#efefef' }}>
          <div className="container">
            <section className="mt-5">
              <div className="row text-center d-flex justify-content-center pt-5">
                <div className="col-md-2">
                  <h6 className="text-uppercase font-weight-bold">
                    <Link to={'/'} className="text-dark">About us</Link>
                  </h6>
                </div>

                <div className="col-md-2">
                  <h6 className="text-uppercase font-weight-bold">
                    <Link to={'/products'} className="text-dark">Products</Link>
                  </h6>
                </div>



                <div className="col-md-2">
                  <h6 className="text-uppercase font-weight-bold">
                    <Link to={'/'} className="text-dark">Help</Link>
                  </h6>
                </div>

                <div className="col-md-2">
                  <h6 className="text-uppercase font-weight-bold">
                    <Link to={'/'} className="text-dark">Contact</Link>
                  </h6>
                </div>
              </div>
            </section>

            <hr className="my-5" />

            <section className="mb-5">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-8">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt
                    distinctio earum repellat quaerat voluptatibus placeat nam,
                    commodi optio pariatur est quia magnam eum harum corrupti
                    dicta, aliquam sequi voluptate quas.
                  </p>
                </div>
              </div>
            </section>

            <section className="text-center mb-5">
              <a href="/" className="text-dark me-4">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="/" className="text-dark me-4">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="/" className="text-dark me-4">
                <i className="fab fa-google"></i>
              </a>
              <a href="/" className="text-dark me-4">
                <i className="fab fa-instagram"></i>
              </a>
              <Link to={'/'} className="text-dark me-4">
                <i className="fab fa-linkedin"></i>
              </Link>
              <Link to={''} className="text-dark me-4">
                <i className="fab fa-github"></i>
              </Link>
            </section>
          </div>

          <div
            className="text-center p-3"
            style={{ backgroundColor: " rgba(0, 0, 0, 0.2)" }}
          >
            © 2020 Copyright:
            <Link className="text-dark" to={'/'}
            >hrcollections.com</Link >
          </div>
        </footer>
      </div>

    </div>
  )
}

export default Footer